import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Hotel } from "../Types/hotelTypes";

export const hotelsApi = createGenericApiSlice<Hotel>({
	reducerPath: "hotelsApi",
	tag: TagTypes.Hotel,
	endpoint: "hotels",
});

export const {
	useGetAllQuery: useGetHotelsQuery,
	useGetByIdQuery: useGetHotelByIdQuery,
	useCreateMutation: useCreateHotelMutation,
	useUpdateMutation: useUpdateHotelMutation,
	useDeleteMutation: useDeleteHotelMutation,
} = hotelsApi;
